import { render, staticRenderFns } from "./DepartmentFunctionSelection.vue?vue&type=template&id=3527d591&"
import script from "./DepartmentFunctionSelection.vue?vue&type=script&lang=js&"
export * from "./DepartmentFunctionSelection.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentFunctionSelection.vue?vue&type=style&index=0&id=3527d591&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports